import { Link } from 'react-router-dom'

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-surface-dark p-4 sm:p-6 pb-20">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="text-accent hover:text-accent-hover mb-8 block">
          ← Back
        </Link>

        <h1 className="text-headline-lg mb-8">Terms of Service</h1>

        <div className="prose prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-headline-md mb-3">1. Acceptable Use</h2>
            <p className="text-body-md text-text-secondary">
              You agree to submit reports in good faith and not to abuse the system.
              Reports must be factual and relate to real infrastructure issues.
              You may not submit spam, false reports, or content that violates local laws.
            </p>
          </section>

          <section>
            <h2 className="text-headline-md mb-3">2. Liability</h2>
            <p className="text-body-md text-text-secondary">
              Snagmatic is provided "as is." We are not liable for delays in responder action or outcomes.
              Responding organizations are independent entities; we facilitate reporting but do not guarantee action.
            </p>
          </section>

          <section>
            <h2 className="text-headline-md mb-3">3. Content Rights</h2>
            <p className="text-body-md text-text-secondary">
              By submitting a report, you grant Snagmatic permission to store, process, and share it with relevant authorities.
              You retain ownership of your photographs.
            </p>
          </section>

          <section>
            <h2 className="text-headline-md mb-3">4. Changes to Terms</h2>
            <p className="text-body-md text-text-secondary">
              We may update these terms at any time. Continued use of the service means acceptance of new terms.
            </p>
          </section>

          <section>
            <h2 className="text-headline-md mb-3">5. Contact</h2>
            <p className="text-body-md text-text-secondary">
              Questions? Email us at support@snagmatic.com
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
